import {
  TextField,
  MenuItem,
  TextFieldProps,
  IconButton,
  Tooltip,
  InputAdornment,
} from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Option {
  value: string;
  label: string;
}

interface NavigatableSelectProps
  extends Omit<TextFieldProps, 'onChange' | 'select' | 'value'> {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: Option[];
  linkTo: string;
  tooltip?: string;
  icon?: React.ReactNode;
  MenuItemProps?: Record<string, any>;
}

export default function NavigatableSelect({
  value,
  onChange,
  options,
  linkTo,
  tooltip = '',
  icon = <OpenInNew fontSize="small" />,
  MenuItemProps = {},
  ...textFieldProps
}: NavigatableSelectProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(linkTo);
  };

  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={onChange}
      select
      // fullWidth
      sx={{
        '& .MuiSelect-icon': {
          marginRight: '24px',
        },
        ...(textFieldProps.sx || {}),
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end" 
            // sx={{backgroundColor: 'pink'}}
            >
              <Tooltip title={tooltip}>
                <IconButton
                  onClick={handleClick}
                  edge="end"
                  size="small"
                  sx={{
                    padding: '0px',
                    color: 'inherit',
                    '& svg': {
                      fontSize: '15px',
                    },
                  }}
                >
                  {icon}
                </IconButton>

              </Tooltip>
            </InputAdornment>
          ),
        },
      }}
    >
      {options.length === 0 ? (
        <MenuItem value="" disabled>
          No options available.
        </MenuItem>
      ) : (
        options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} {...MenuItemProps}>
            {opt.label}
          </MenuItem>
        ))
      )}
    </TextField>
  );
}
